<template>
  <div>

    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-9 col-sm-1">
                <v-text-field label="Nome" v-model="current.name" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
                <v-text-field label="Código" v-model="current.code" outlined dense disabled></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>

    <v-tabs v-model="tab" grow class="mt-2">
        <v-tab key="bd">
            PLACAS
        </v-tab>
        <v-tab key="dy">
            DISCOVERY
        </v-tab>
        <v-tab key="ot">
            ONT
        </v-tab>
        <v-tab key="sp">
            SERVICE-PORT
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
        <v-tab-item key="bd">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-btn color="primary" @click="boardSync()" class="ma-2" v-if="$auth.check('ROLE_ADMIN')">Sincronizar placas</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-alert dense text type="info" class="ma-2">
                    {{ counter_board }} registros encontrados
                    </v-alert>
                </v-col>
            </v-row>
            <v-card flat>
                <v-card-text>
                    <v-simple-table v-if="boards">
                        <thead>
                            <tr>
                            <th>F/S</th>
                            <th>Modelo</th>
                            <th>Portas</th>
                            <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in boards" :key="item.id">
                            <td>{{ item.frame }}/{{ item.slot }}</td>
                            <td>{{ item.model }}</td>
                            <td>{{ item.ports }}</td>
                            <td>{{ item.status }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-tab-item>
        <v-tab-item key="dy">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-btn color="primary" @click="ontDiscovery()" class="ma-2" v-if="$auth.check('ROLE_ADMIN')">Descobrir ONTs</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-alert dense text type="info" class="ma-2">
                    {{ counter_discovery }} registros encontrados
                    </v-alert>
                </v-col>
            </v-row>
            <v-card flat>
                <v-card-text>
                    <v-simple-table v-if="discovery">
                        <thead>
                            <tr>
                            <th>F/S/P</th>
                            <th>Serial</th>
                            <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in discovery" :key="item.id">
                            <td>{{ item.frame }}/{{ item.slot }}/{{ item.port }}</td>
                            <td>{{ item.serial }}</td>
                            <td><v-btn color="success" @click="ontSetupDialog(item)">setup</v-btn></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-tab-item>
        <v-tab-item key="ot">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-btn color="primary" @click="ontSync()" class="ma-2" v-if="$auth.check('ROLE_ADMIN')">Sincronizar ONTs</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-alert dense text type="info" class="ma-2">
                    {{ counter_ont }} registros encontrados
                    </v-alert>
                </v-col>
            </v-row>
            <v-card flat>
                <v-card-text>
                    <v-simple-table v-if="onts">
                        <thead>
                            <tr>
                            <th>F/S/P</th>
                            <th>ONTID</th>
                            <th>Serial</th>
                            <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in onts" :key="item.id">
                            <td>{{ item.frame }}/{{ item.slot }}/{{ item.port }}</td>
                            <td>{{ item.ontid }}</td>
                            <td>{{ item.serial }}</td>
                            <td>
                                <v-btn small color="primary" @click="ontInfo(item)">info</v-btn>&nbsp;
                                <v-btn small color="warning" @click="ontOptical(item)">optical</v-btn>&nbsp;
                                <v-btn small color="secondary" @click="ontPower(item)">power</v-btn>&nbsp;
                            </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-tab-item>
        <v-tab-item key="sp">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-btn color="primary" @click="servicePortSync()" class="ma-2" v-if="$auth.check('ROLE_ADMIN')">Sincronizar Service-port</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-alert dense text type="info" class="ma-2">
                    {{ counter_service_port }} registros encontrados
                    </v-alert>
                </v-col>
            </v-row>
            <v-card flat>
                <v-card-text>
                    <v-simple-table v-if="sports">
                        <thead>
                            <tr>
                            <th>Index</th>
                            <th>Tipo</th>
                            <th>F/S/P</th>
                            <th>VPI</th>
                            <th>VCI</th>
                            <th>S-VLAN</th>
                            <th>U-VLAN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in sports" :key="item.id">
                            <td>{{ item.index }}</td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.fsp }}</td>
                            <td>{{ item.vpi }}</td>
                            <td>{{ item.vci }}</td>
                            <td>{{ item.vlanOut }}</td>
                            <td>{{ item.vlanIn }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialog_ont_setup" max-width="500px" v-if="current_ont">
        <v-card>
            <v-card-title>ONT - Setup</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <v-text-field label="Frame" v-model="current_ont.frame" outlined dense disabled></v-text-field>
                    <v-text-field label="Slot" v-model="current_ont.slot" outlined dense disabled></v-text-field>
                    <v-text-field label="Port" v-model="current_ont.port" outlined dense disabled></v-text-field>
                    <v-text-field label="Serial" v-model="current_ont.serial" outlined dense disabled></v-text-field>
                    <v-text-field label="User VLAN" v-model="current_ont.uvlan" outlined dense></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="success" @click="ontSetup()">Ativar</v-btn>
                <v-btn color="default" @click="dialog_ont_setup = false">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_sp_setup" max-width="500px" v-if="current_ont">
        <v-card>
            <v-card-title>Service-Port - Setup</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <v-text-field label="Frame" v-model="current_ont.frame" outlined dense disabled></v-text-field>
                    <v-text-field label="Slot" v-model="current_ont.slot" outlined dense disabled></v-text-field>
                    <v-text-field label="Port" v-model="current_ont.port" outlined dense disabled></v-text-field>
                    <v-text-field label="ONTID" v-model="current_ont.ontid" outlined dense disabled></v-text-field>
                    <v-text-field label="Serial" v-model="current_ont.serial" outlined dense disabled></v-text-field>
                    <v-text-field label="User VLAN" v-model="current_ont.uvlan" outlined dense disabled></v-text-field>
                    <v-text-field label="Service VLAN" v-model="current_ont.svlan" outlined dense></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="success" @click="servicePortSetup()">Configurar</v-btn>
                <v-btn color="default" @click="dialog_sp_setup = false">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_optical" max-width="700px" v-if="current_optical">
        <v-card>
            <v-card-title>ONT - Optical</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <pre>{{ current_optical }}</pre>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="dialog_ont_optical = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_info" max-width="700px" v-if="current_info">
        <v-card>
            <v-card-title>ONT - Info</v-card-title>
            <v-card-text>
                <div class="col-md-9 col-sm-1">
                    <pre>{{ current_info }}</pre>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="dialog_ont_info = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_ont_power" max-width="700px" v-if="current_power">
        <v-card>
            <v-card-title>ONT - Power</v-card-title>
            <v-card-text>
                <v-simple-table v-if="discovery">
                        <thead>
                            <tr>
                            <th>Serial</th>
                            <th>Power</th>
                            <th>Horário</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in current_power" :key="item.id">
                            <td>{{ item.serial }}</td>
                            <td>{{ item.power }}</td>
                            <td>{{ item.time }}</td>
                            </tr>
                        </tbody>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="dialog_ont_power = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
    data: () => ({
        current: null,
        current_ont: null,
        current_optical: null,
        current_info: null,
        current_power: [],
        boards: [],
        onts: [],
        sports: [],
        discovery: [],
        tab: null,
        dialog_ont_setup: false,
        dialog_sp_setup: false,
        dialog_ont_optical: false,
        dialog_ont_info: false,
        dialog_ont_power: false,
        dialog_loading: false,
        counter_board: 0,
        counter_discovery: 0,
        counter_ont: 0,
        counter_service_port: 0
    }),
    created: function() {
      this.load();
      this.loadBoards();
      this.loadONTs();
      this.loadServicePorts();
    },
    methods: {
      load: function() {
        var me = this;
        var token = localStorage.getItem("token");
        api
            .get("/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.current = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
      },
      loadBoards: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api
            .get("/olt_board/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.boards = response.data;
                me.counter_board = me.boards.length;
            })
            .catch(function(error) {
                console.log(error);
            });
      },
      loadONTs: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api
            .get("/ont/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.onts = response.data;
                me.counter_ont = me.onts.length;
            })
            .catch(function(error) {
                console.log(error);
            });
      },
      loadServicePorts: function(){
        var me = this;
        var token = localStorage.getItem("token");
        api
            .get("/olt_service_port/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.sports = response.data;
                me.counter_service_port = me.sports.length;
            })
            .catch(function(error) {
                console.log(error);
            });
      },
      boardSync: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .post("/olt_board/sync/" + this.current.id, null, { headers: { Authorization: "Bearer " + token } })
            .then(function() {
                me.dialog_loading = false;
                alert("Placas sincronizadas com sucesso!");
                me.loadBoards();
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao sincronizar placas!");
                console.log(error);
            });
      },
      ontDiscovery: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/discovery/" + this.current.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.discovery = response.data;
                me.counter_discovery = me.discovery.length;
                if(response.data.length==0){
                    alert("Nenhuma ONT encontrada!");
                }
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao descobrir ONT!");
                console.log(error);
            });
      },
      ontSync: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .post("/ont/sync/" + this.current.id, null, { headers: { Authorization: "Bearer " + token } })
            .then(function() {
                me.dialog_loading = false;
                alert("ONT sincronizadas com sucesso!");
                me.loadONTs();
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao sincronizar ONT!");
                console.log(error);
            });
      },
      ontSetupDialog: function(ont){
          this.current_ont = ont;
          this.current_ont.uvlan = 10;
          this.dialog_ont_setup = true;
      },
      ontSetup: function(){
        var me = this;
        var token = localStorage.getItem("token");
        var uvlan = this.current_ont.uvlan;
        me.dialog_loading = true;
        api
            .post("/ont/setup/"+uvlan, this.current_ont, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                alert("ONT Setup executado com sucesso!");
                me.dialog_ont_setup = false;
                me.current_ont = response.data;
                me.current_ont.uvlan = uvlan;
                me.current_ont.svlan = uvlan;
                me.discovery = [];
                me.dialog_sp_setup = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha no ONT setup!");
                console.log(error);
            });
      },
      ontInfo: function(item){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/info/" + item.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.current_info  = response.data;
                me.dialog_ont_info = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao recuperar ont info!");
                console.log(error);
            });
      },
      ontOptical: function(item){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/optical/" + item.id, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.current_optical  = response.data;
                me.dialog_ont_optical = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao recuperar ont optical!");
                console.log(error);
            });
      },
      ontPower: function(item){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .get("/ont/power/" + item.serial, { headers: { Authorization: "Bearer " + token } })
            .then(function(response) {
                me.dialog_loading = false;
                me.current_power  = response.data;
                me.dialog_ont_power = true;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao recuperar ont power!");
                console.log(error);
            });
      },
      servicePortSync: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
            .post("/olt_service_port/sync/" + this.current.id, null, { headers: { Authorization: "Bearer " + token } })
            .then(function() {
                me.dialog_loading = false;
                alert("Service-port sincronizado com sucesso!");
                me.loadServicePorts();
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha ao sincronizar service-port!");
                console.log(error);
            });
      },
      servicePortSetup: function(){
        var me = this;
        var token = localStorage.getItem("token");
        var sp = { 
            oltId: this.current_ont.oltId, 
            fsp: this.current_ont.frame +"/"+this.current_ont.slot+"/"+this.current_ont.port,
            vpi: this.current_ont.ontid,
            vlanOut: parseInt(this.current_ont.svlan),
            vlanIn: parseInt(this.current_ont.uvlan)
        };
        me.dialog_loading = true;
        api
            .post("/olt_service_port/setup", sp, { headers: { Authorization: "Bearer " + token } })
            .then(function() {
                me.dialog_loading = false;
                alert("Service-Port Setup executado com sucesso!");
                me.current_ont = null;
                me.dialog_sp_setup = false;
            })
            .catch(function(error) {
                me.dialog_loading = false;
                alert("Falha no setup de service-port!");
                console.log(error);
            });
      }
    }
}
</script>